import React from 'react';
import { clientLogos } from '../mockData';

/**
 * ClientsMarquee — infinite scrolling strip of real client logos.
 * Uses a duplicated row for seamless looping.
 */
const ClientsMarquee = () => {
  const row = (
    <div className="flex items-center gap-10 md:gap-16 shrink-0 pr-10 md:pr-16">
      {clientLogos.map((c) => (
        <div
          key={`${c.id}-${c.src}`}
          className="w-36 md:w-40 h-14 md:h-16 flex items-center justify-center shrink-0"
          data-testid={`client-logo-${c.id}`}
        >
          <img
            src={c.src}
            alt={c.alt}
            loading="lazy"
            decoding="async"
            className="max-w-full max-h-full object-contain grayscale opacity-70 hover:opacity-100 hover:grayscale-0 transition-all duration-500"
          />
        </div>
      ))}
    </div>
  );

  return (
    <section
      className="bg-brand-alabaster border-y border-brand-hairline py-12 md:py-14"
      aria-label="Selected clients"
      data-testid="clients-marquee"
    >
      <div className="container-editorial mb-8 flex items-center justify-between gap-4 flex-wrap">
        <div className="flex items-center gap-4">
          <span className="hairline" aria-hidden />
          <span className="eyebrow">Selected Clients &amp; Partners</span>
        </div>
        <p className="text-sm text-brand-slate max-w-md">
          Trusted by 18,000+ manufacturers, importers and enterprises across 12 countries.
        </p>
      </div>
      <div className="relative overflow-hidden">
        {/* Soft fade edges */}
        <div className="pointer-events-none absolute inset-y-0 left-0 w-16 md:w-32 bg-gradient-to-r from-brand-alabaster to-transparent z-10" aria-hidden />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-16 md:w-32 bg-gradient-to-l from-brand-alabaster to-transparent z-10" aria-hidden />
        <div className="flex animate-marquee will-change-transform">
          {row}
          {row}
        </div>
      </div>
    </section>
  );
};

export default ClientsMarquee;
